import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SpinnerWrapper, Spinner } from '../../DecisionTree.styles';
import * as colors from '../../../common/colorConstants';
import { isGotHereByBackButton, selectError } from '../../../../selectors/checkOrderDate';
import { checkOrderDate, resetCheckOrderDateStore } from '../../../../actions/tools/CheckOrderDateActions';
import { showExpressError } from '../../../../util/errorPopupUtil';
import { returnToPreviousMacroWizardPath } from '../../../../actions/searchActions';

const DTCheckOrderDateNode = () => {
  const dispatch = useDispatch();
  const error = useSelector(selectError);
  const gotHereByBackButton = useSelector(isGotHereByBackButton);

  useEffect(() => {
    if (gotHereByBackButton) {
      dispatch(returnToPreviousMacroWizardPath());
      dispatch(resetCheckOrderDateStore());
    } else {
      dispatch(checkOrderDate());
    }
  }, [dispatch, gotHereByBackButton]);

  if (error) {
    showExpressError(error, error.message);
  }

  return (
    <SpinnerWrapper>
      <Spinner color={colors.purple1} />
    </SpinnerWrapper>
  );
};

export default DTCheckOrderDateNode;
